import { X, MapPin, Calendar, Users } from 'lucide-react';
import { TrainingCamp } from '../../lib/types';

interface TrainingCampModalProps {
  camp: TrainingCamp;
  onClose: () => void;
}

export function TrainingCampModal({ camp, onClose }: TrainingCampModalProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        <div className="relative">
          <img
            src={camp.imageUrl}
            alt={camp.title}
            className="w-full h-64 object-cover rounded-t-xl"
          />
          <button
            onClick={onClose}
            className="absolute top-4 right-4 bg-white rounded-full p-2 shadow-lg hover:bg-gray-100"
          >
            <span className="sr-only">Închide</span>
            ×
          </button>
        </div>
        
        <div className="p-6">
          <h2 className="text-3xl font-bold mb-2">{camp.title}</h2>
          <div className="flex items-center gap-2 text-gray-600 mb-4">
            <MapPin size={20} />
            <span>{camp.location}</span>
          </div>
          
          <div className="flex flex-wrap gap-4 mb-6">
            <div className="flex items-center gap-2 bg-orange-100 text-orange-800 px-3 py-1 rounded-full">
              <Calendar size={16} />
              <span>{new Date(camp.startDate).toLocaleDateString('ro-RO')} - {new Date(camp.endDate).toLocaleDateString('ro-RO')}</span>
            </div>
            <div className="flex items-center gap-2 bg-green-100 text-green-800 px-3 py-1 rounded-full">
              <Users size={16} />
              <span>Capacitate: {camp.capacity} locuri</span>
            </div>
          </div>

          <div className="prose max-w-none mb-8">
            <p className="text-lg">{camp.description}</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div>
              <h3 className="text-xl font-semibold mb-4">Ce este inclus:</h3>
              <ul className="space-y-2">
                {camp.included.map((item, index) => (
                  <li key={index} className="flex items-center gap-2">
                    <span className="text-green-500">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Cerințe:</h3>
              <ul className="space-y-2">
                {camp.requirements.map((req, index) => (
                  <li key={index} className="flex items-center gap-2">
                    <span className="text-orange-500">•</span>
                    {req}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="flex items-center justify-between border-t pt-6">
            <div>
              <p className="text-gray-600">Preț per persoană</p>
              <p className="text-3xl font-bold">{camp.price} €</p>
            </div>
            <button className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-lg font-semibold transition-colors">
              Înscrie-te acum
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}